import React, { memo } from 'react';
import PropTypes from 'prop-types';

const FormGroup = ({ children, className = '', ...props }) => {
    return (
        <div
            className={className}
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem',
                marginBottom: '2rem',
            }}
            {...props}
        >
            {children}
        </div>
    );
};

FormGroup.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default memo(FormGroup);
